<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="(item.tag || item.tagStoreKey) && (item.tagStoreKey ? navTagStore[item.tagStoreKey] : item.tag) > 0 "
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tagStoreKey ? navTagStore[item.tagStoreKey] : item.tag }}
      </b-badge>
      <b-badge 
        v-if="item.title === 'Notifications'"
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ unreadNotifications.length }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive, navTagStore } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()

    return {
      isActive,
      linkProps,
      navTagStore,
      updateIsActive,

      // i18n
      t,
    }
  },
  computed: {
    unreadNotifications(){
      return this.$store.getters[`notifications/unreadNotifications`]
    },
  }
}
</script>
